(ns minorodata.connections.sources.salesforce
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description
  (spec/nilable string?))


(spec/def ::auth-credentials-id
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Please provide a valid auth token"})))


(spec/def ::auth-credentials
  (spec/keys :req-un [::auth-credentials-id]))


(spec/def ::salesforce-form
  (spec/keys :req-un [::name ::auth-credentials]
             :opt-un [::description]))


(def source
  {:id                    "salesforce-oauth"
   :enabled               true
   :message-queue-enabled true
   :name                  "Salesforce"
   :description           "CRM software solutions and enterprise cloud computing"
   :image-source          "salesforce.svg"
   :tags                  ["admin-finance"]

   :preview-formatter (fn [source]
                        (if (:is-token-valid source)
                          (str "Authenticated by token")
                          [:span {:class "text-kleene-error-01"
                                  :title         "TOKEN EXPIRED"}
                           "AUTH TOKEN EXPIRED"]))

   :form              {:format-for-api
                       (fn format-for-api [{:keys [auth-credentials name description use-custom-exchange-url exchange-url]}]
                         {:source-type "salesforce-oauth"
                          :name        name
                          :description description
                          :source      {:auth-credentials-id     (:auth-credentials-id auth-credentials)
                                        :is-token-valid          (:is-token-valid auth-credentials)
                                        :instance-url            (:instance-url auth-credentials)
                                        :has-third-leg           true
                                        :use-custom-exchange-url use-custom-exchange-url
                                        :exchange-url            exchange-url}})

                       :format-for-inputs
                       (fn format-for-inputs [{:keys [source name description]}]
                         (let [{:keys [auth-credentials-id is-token-valid instance-url use-custom-exchange-url exchange-url]} source]
                           (app.utils/keep-non-nil-keys
                             {:name                    name
                              :description             description
                              :auth-credentials        (when (and (some? auth-credentials-id)
                                                                  (some? is-token-valid))
                                                         {:auth-credentials-id auth-credentials-id
                                                          :is-token-valid      is-token-valid
                                                          :instance-url        instance-url})
                              :auth-credentials-id     auth-credentials-id
                              :is-token-valid          is-token-valid
                              :instance-url            instance-url
                              :use-custom-exchange-url use-custom-exchange-url
                              :exchange-url            exchange-url})))

                       ;; TODO:
                       ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
                       ;; {:block-type :input
                       ;;  :name       :some-name
                       ;;  :mapping    [:credentials :some_name]}
                       ;; Also, think of having `:input-type :hidden` blocks as placeholders
                       ;; for static fields in the final configuration.

                       :validate
                       (partial form-component/validate-form ::salesforce-form)

                       :id
                       :salesforce-oauth-form

                       :blocks
                       [{:block-type :input
                         :label      "Source name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type :checkbox
                         :label      "Use custom exchange url"
                         :name       :use-custom-exchange-url
                         :type       :checkbox
                         :value      false}

                        {:block-type :input
                         :label      "Exchange url"
                         :name       :exchange-url
                         :doc        [:span "See documentation " [:a {:href "https://help.salesforce.com/s/articleView?id=sf.remoteaccess_oauth_endpoints.htm" :target :_blank} "here"] " for more information"]
                         :value      "https://test.salesforce.com/services/oauth2/token"
                         :conditions [[:eq [:use-custom-exchange-url :value] true]]}

                        {:block-type           :oauth
                         :label                "Salesforce Login"
                         :name                 :auth-credentials
                         :required             true

                         :request-uri          "https://login.salesforce.com/services/oauth2/authorize"
                         :params-processor     (fn [{:keys [client-id redirect-uri state scope response-type]}]
                                                 {:response_type response-type
                                                  :scope         scope
                                                  :client_id     client-id
                                                  :redirect_uri  redirect-uri
                                                  :state         state})

                         :response-processor   (fn [data]
                                                 (select-keys data [:auth-credentials-id :is-token-valid :instance-url]))

                         :oauth-connector-type "salesforce"
                         :has-third-leg        true

                         :response-type        "code"
                         :client-id            "3MVG9I9urWjeUW06__87IBg7BULBQFb264RbzNGx5gWp4chJQO4IVk63GcbqF57u7.Rj36H28OzoSMpds.Tt5"
                         :scope                "api web refresh_token cdp_query_api"}

                        {:block-type :submit
                         :content    "SAVE"}]}

   :extract-form      {:format-for-api
                       (fn format-for-api [{:keys [name description status
                                                   action destination-table report
                                                   extract-type query]}]
                         {:name          name
                          :description   description
                          :status        status
                          :output-tables [destination-table]
                          :config        {:extracts [{:action            action
                                                      :report            report
                                                      :destination-table destination-table
                                                      :extract-type      extract-type
                                                      :query             query}]}})

                       :format-for-inputs
                       (fn format-for-inputs [{:extract/keys [name description status config source-id]}]
                         (let [extract (get-in config [:extracts 0])]
                           (merge
                            (select-keys extract [:report :action :destination-table :extract-type :query])
                            (app.utils/keep-non-nil-keys
                             {:name          name
                              :description   description
                              :status        status
                              :output-tables []

                              :source-id     source-id}))))

                       :validate
                       (constantly nil)

                       :id
                       :salesforce-oauth-extract-form

                       :blocks
                       [{:block-type :input
                         :label      "Extract name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type :select
                         :label      "Status"
                         :name       :status
                         :options    [{:name "Active" :value "active"}
                                      {:name "Paused" :value "paused"}]
                         :required   true
                         :value      "active"}

                        {:block-type :subtitle
                         :content    "Extract Configuration"}

                        {:block-type :form-value
                         :name       :source-id}

                        {:block-type :select
                         :label      "Report"
                         :name       :report
                         :options    [{:name "Custom report (SOQL, Bulk API)"   :value "custom-report"}
                                      {:name "Data Cloud query (SQL)"           :value "data-cloud-query"}]
                         :disabled   false
                         :required   true
                         :value      "custom-report"}

                        {:content    "SOQL query run through the Bulk API 2.0 against standard and custom objects, e.g. SELECT Id, Name FROM Account"
                         :conditions [[:eq [:report :value] "custom-report"]]}

                        {:content    "ANSI SQL query run through the Data Cloud (Data 360) query API against Data Model Objects, e.g. SELECT * FROM ssot__AiAgentSession__dlm"
                         :conditions [[:eq [:report :value] "data-cloud-query"]]}

                        {:block-type  :input
                         :label       "Query"
                         :name        :query
                         :required    true
                         :value       ""
                         :placeholder "SELECT Id, Name FROM Account"
                         :conditions  [[:eq [:report :value] "custom-report"]]}

                        {:block-type  :input
                         :label       "Query"
                         :name        :query
                         :required    true
                         :value       ""
                         :placeholder "SELECT * FROM ssot__AiAgentSession__dlm"
                         :conditions  [[:eq [:report :value] "data-cloud-query"]]}

                        {:block-type :select
                         :label      "Load method"
                         :name       :action
                         :options    [{:name "Drop, Create, Load" :value "replace"}
                                      {:name "Truncate, Load"     :value "reload"}
                                      {:name "Append"             :value "append"}]
                         :required   true
                         :value      "replace"}

                        {:content "Drop table, Create table, load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "replace"]]}

                        {:content "Truncate table, Load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "reload"]]}

                        {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
                         :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "full-load"]]]}

                        {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
                         :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

                        {:block-type :subtitle
                         :content    "Destination table"}

                        {:block-type  :warehouse-destination
                         :name        :destination-table}

                        {:block-type :submit
                         :content    "SAVE"}]}})
